<template>
	<div class="LoginAndFreeTrial">
		<!-- <el-button
      type="text"
      @click="dialogVisible = true"
    >
      click to open the Dialog
    </el-button> -->
		<span>
			<el-dialog
				:visible.sync="dialogVisible"
				:before-close="closeLoginDialog"
				:close-on-click-modal="false"
			>
				<div class="LoginAndFreeTrial__links">
					<ul>
						<!-- <li
							:class="{ active_link: showFreeTrialModel }"
							@click="showPerticularSection('start_trial')"
						>
							REQUEST DEMO
						</li> -->
						<!-- <li
							:class="{ active_link: showFreeTrialModel }"
							@click="showPerticularSection('start_trial')"
						>
							START FREE TRIAL
						</li> -->
						<li
							:class="{ active_link: !showFreeTrialModel }"
							@click="showPerticularSection('login')"
						>
							LOGIN
						</li>
					</ul>
				</div>
				<div v-if="showFreeTrialModel" class="LoginAndFreeTrial_trial_section">
					<h5 class="LoginAndFreeTrial_title">
						Try NymbleUp for free
					</h5>
					<p class="LoginAndFreeTrial_text">
						No credit card required. Get started in less than 5 minutes.
					</p>
					<div class="LoginAndFreeTrial_input_section">
						<form @submit.prevent>
							<el-row :gutter="10">
								<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
									<div
										class="form-group1"
										:class="{ 'not-empty1': full_name }"
									>
										<input
											v-model="full_name"
											v-validate="'required'"
											type="text"
											class="form-control1"
											name="Full Name"
											autocomplete="full_name"
										/>
										<label for="user" class="animated-label1">
											Full Name<span class="text-red">
												*
											</span>
										</label>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("First Name") }}
									</span>
								</el-col>
								<!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
									<div
										class="form-group1"
										:class="{ 'not-empty1': last_name.length }"
									>
										<input
											v-model="last_name"
											v-validate="'required|alpha'"
											type="text"
											class="form-control1"
											name="Last Name"
											autocomplete="last_name"
										/>
										<label for="user" class="animated-label1">
											Last Name<span class="text-red">
												*
											</span>
										</label>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("Last Name") }}
									</span>
								</el-col> -->
							</el-row>
							<el-row>
								<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
									<div
										class="form-group1"
										:class="{ 'not-empty1': email.length }"
									>
										<input
											v-model="email"
											v-validate="'required|email'"
											type="email"
											class="form-control1"
											name="email address"
											autocomplete="email"
										/>
										<label for="user" class="animated-label1">
											Email<span class="text-red">
												*
											</span>
										</label>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("email address") }}
									</span>
								</el-col>
							</el-row>
						</form>
					</div>
					<a class="LoginAndFreeTrial_already_account">
						Already have an account?<span
							class=""
							@click="showPerticularSection('login')"
						>
							Log In
						</span>
					</a>
					<span slot="footer" class="dialog-footer">
						<div class="LoginAndFreeTrial_button">
							<el-button type="primary" @click="checkEmailStatus()">
								SIGN UP
							</el-button>
						</div>
					</span>
				</div>
				<!-- <div v-if="showFreeTrialModel" class="LoginAndFreeTrial_trial_section">
					<h5 class="LoginAndFreeTrial_title">
						Fill out this form and find out more about NymbleUp
					</h5>
					<div class="LoginAndFreeTrial_input_section">
						<form @submit.prevent>
							<div class="mt-2">
								<el-alert
									v-if="submited"
									title="Thank you for sharing your details.
									one of our team member will get in touch with you shortly"
									type="warning"
									description="">
								</el-alert>
							</div>
							<el-row :gutter="10">
								<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
									<div>
										<p class="text-grey text-sm pt-2 pb-1">Name<span style="color:red;">
										*
									</span></p>
										<el-input v-model="name" v-validate="'required'" name="Name" size="medium" placeholder="Enter your full name" style="width:100%;"></el-input>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("Name") }}
									</span>
								</el-col>
								<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
									<div>
										<p class="text-grey text-sm pt-4 pb-1">Company Name<span style="color:red;">
										*
									</span></p>
										<el-input v-model="business_name" v-validate="'required'" name="Business Name" size="medium" placeholder="Enter your company name" style="width:100%;"></el-input>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("Business Name") }}
									</span>
								</el-col>
							</el-row>
							<el-row>
								<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
									<div>
										<p class="text-grey text-sm pt-4 pb-1">Email<span style="color:red;">
										*
									</span></p>
										<el-input v-model="email" v-validate="'required|email'" size="medium" placeholder="Enter your email address" name="email address" style="width:100%;"></el-input>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("email address") }}
									</span>
								</el-col>
							</el-row>
							<el-row>
								<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
									<div>
										<p class="text-grey text-sm pt-4 pb-1">Phone Number<span style="color:red;">
										*
									</span></p>
										<vue-tel-input v-model="phone" v-validate="'required'" name="phone" size="medium" style="width:100%;"></vue-tel-input>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("phone") }}
									</span>
								</el-col>
							</el-row>
						</form>
					</div>
					<span slot="footer" class="dialog-footer">
						<div class="LoginAndFreeTrial_button">
							<el-button type="primary" @click="addRequestStatus()">
								SUBMIT
							</el-button>
						</div>
					</span>
				</div> -->
				<div v-if="!showFreeTrialModel" class="LoginAndFreeTrial_login_section">
					<h5 class="LoginAndFreeTrial_title">
						Already have an account?
					</h5>
					<p class="LoginAndFreeTrial_text">
						Sign into your account with your registered email id.
					</p>
					<div class="LoginAndFreeTrial_input_section">
						<el-row>
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
								<div
									class="form-group1"
									:class="{ 'not-empty1': username.length }"
								>
									<input
										v-model="username"
										v-validate="'required|email'"
										data-vv-validate-on="blur"
										type="email"
										class="form-control1"
										name="Email"
										autocomplete="username"
									/>
									<label for="user" class="animated-label1">
										Email Address
									</label>
								</div>
								<span class="text-red-dark text-xs">
									{{ errors.first("Email") }}
								</span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
								<div
									class="form-group1"
									:class="{ 'not-empty1': password.length }"
								>
									<!-- v-validate.bails="'required|min:8|verify_password'" -->
									<input
										v-model="password"
										type="password"
										class="form-control1"
										name="Password"
										@keyup.13="clickForLogin"
									/>
									<label for="user" class="animated-label1">
										Password
									</label>
								</div>
								<span class="text-red-dark text-xs">
									{{ errors.first("Password") }}
								</span>
							</el-col>
						</el-row>
					</div>
					<a
						class="LoginAndFreeTrial_forgot_password"
						@click="openForgotPassword()"
					>
						Forgot Your Password?
					</a>
					<span slot="footer" class="dialog-footer">
						<div class="LoginAndFreeTrial_button">
							<el-button type="primary" @click="clickForLogin">
								LOG IN
							</el-button>
						</div>
					</span>

					<!-- <div class="mt-4">
						<button ref="googleSignIn" class="social-media-login-btn social-media-login-btn--google" style="font-weight: bold;">
							Login with Google
						</button>
					</div> -->
				</div>

			</el-dialog>
		</span>


		<!-- PAssword reset dialog -->
		<el-dialog
				:visible.sync="passwordResetDialog"
				:before-close="closeLoginDialog"
				:close-on-click-modal="false"
			>
				<div class="LoginAndFreeTrial__links">
					<ul>
						<li
							:class="{ active_link: !showFreeTrialModel }"
							@click="showPerticularSection('login')"
						>
							Forgot Password
						</li>
					</ul>
				</div>
				<div v-if="!resetPassMailSent" class="LoginAndFreeTrial_login_section">
					<h5 class="LoginAndFreeTrial_title">
						Reset Your Password.
					</h5>
					<p class="LoginAndFreeTrial_text">
						Lost your password? Please enter your email address. You will receive a link to create a new password via email.
					</p>
					<div class="LoginAndFreeTrial_input_section">
						<el-row>
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
								<div
									class="form-group1"
									:class="{ 'not-empty1': reset_email.length }"
								>
									<input
										v-model="reset_email"
										v-validate="'required|email'"
										data-vv-validate-on="blur"
										type="email"
										class="form-control1"
										name="Reset Email"
										autocomplete="username"
									/>
									<label for="user" class="animated-label1">
										Email Address
									</label>
								</div>
								<span class="text-red-dark text-xs">
									{{ errors.first("Reset Email") }}
								</span>
							</el-col>
						</el-row>
					</div>
					<span slot="footer" class="dialog-footer">
						<div class="LoginAndFreeTrial_button">
							<el-button type="primary" @click="clickForForgot">
								Submit
							</el-button>
						</div>
					</span>
				</div>
				<div v-if="resetPassMailSent">
					<div class="my-8 block mx-auto my-0 text-center">
						<svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" width="150" height="120" viewBox="0 0 570 511.67482"
						xmlns:xlink="http://www.w3.org/1999/xlink">
							<path
								d="M879.99927,389.83741a.99678.99678,0,0,1-.5708-.1792L602.86963,197.05469a5.01548,5.01548,0,0,0-5.72852.00977L322.57434,389.65626a1.00019,1.00019,0,0,1-1.14868-1.6377l274.567-192.5918a7.02216,7.02216,0,0,1,8.02-.01318l276.55883,192.603a1.00019,1.00019,0,0,1-.57226,1.8208Z"
								transform="translate(-315 -194.16259)" fill="#3f3d56" />
							<polygon points="23.264 202.502 285.276 8.319 549.276 216.319 298.776 364.819 162.776 333.819 23.264 202.502"
								fill="#e6e6e6" />
							<path
								d="M489.25553,650.70367H359.81522a6.04737,6.04737,0,1,1,0-12.09473H489.25553a6.04737,6.04737,0,1,1,0,12.09473Z"
								transform="translate(-315 -194.16259)" fill="#e29d5a" />
							<path d="M406.25553,624.70367H359.81522a6.04737,6.04737,0,1,1,0-12.09473h46.44031a6.04737,6.04737,0,1,1,0,12.09473Z"
								transform="translate(-315 -194.16259)" fill="#e29d5a" />
							<path
								d="M603.96016,504.82207a7.56366,7.56366,0,0,1-2.86914-.562L439.5002,437.21123v-209.874a7.00817,7.00817,0,0,1,7-7h310a7.00818,7.00818,0,0,1,7,7v210.0205l-.30371.12989L606.91622,504.22734A7.61624,7.61624,0,0,1,603.96016,504.82207Z"
								transform="translate(-315 -194.16259)" fill="#fff" />
							<path
								d="M603.96016,505.32158a8.07177,8.07177,0,0,1-3.05957-.59863L439.0002,437.54521v-210.208a7.50851,7.50851,0,0,1,7.5-7.5h310a7.50851,7.50851,0,0,1,7.5,7.5V437.68779l-156.8877,66.999A8.10957,8.10957,0,0,1,603.96016,505.32158Zm-162.96-69.1123,160.66309,66.66455a6.1182,6.1182,0,0,0,4.668-.02784l155.669-66.47851V227.33721a5.50653,5.50653,0,0,0-5.5-5.5h-310a5.50653,5.50653,0,0,0-5.5,5.5Z"
								transform="translate(-315 -194.16259)" fill="#3f3d56" />
							<path
								d="M878,387.83741h-.2002L763,436.85743l-157.06982,67.07a5.06614,5.06614,0,0,1-3.88038.02L440,436.71741l-117.62012-48.8-.17968-.08H322a7.00778,7.00778,0,0,0-7,7v304a7.00779,7.00779,0,0,0,7,7H878a7.00779,7.00779,0,0,0,7-7v-304A7.00778,7.00778,0,0,0,878,387.83741Zm5,311a5.002,5.002,0,0,1-5,5H322a5.002,5.002,0,0,1-5-5v-304a5.01106,5.01106,0,0,1,4.81006-5L440,438.87739l161.28027,66.92a7.12081,7.12081,0,0,0,5.43994-.03L763,439.02741l115.2002-49.19a5.01621,5.01621,0,0,1,4.7998,5Z"
								transform="translate(-315 -194.16259)" fill="#3f3d56" />
							<path
								d="M602.345,445.30958a27.49862,27.49862,0,0,1-16.5459-5.4961l-.2959-.22217-62.311-47.70752a27.68337,27.68337,0,1,1,33.67407-43.94921l40.36035,30.94775,95.37793-124.38672a27.68235,27.68235,0,0,1,38.81323-5.12353l-.593.80517.6084-.79346a27.71447,27.71447,0,0,1,5.12353,38.81348L624.36938,434.50586A27.69447,27.69447,0,0,1,602.345,445.30958Z"
							transform="translate(-315 -194.16259)" fill="#e29d5a" />
						</svg>
						<h3 class="my-2">Email sent successfully</h3>
						<p class="my-2">Please check you email, you will receive a link to create a new password via email</p>
					</div>
				</div>
			</el-dialog>
	</div>
</template>

<script>
// const axios = require("axios");
import { VueTelInput } from 'vue-tel-input'
import { serverAddr } from "../../networkConfig";
import { LoginAndFreeTrialNC } from "../../../mixins/LoginAndFreeTrialNC";
import CommonService from "../../services/commonService";

export default {
	name: "LoginAndFreeTrial",
	mixins: [LoginAndFreeTrialNC],
	components: {
        VueTelInput
    },
	props: [],
	data() {
		return {
			dialogVisible: this.$store.state.show_login_and_freeTrial_model,
			passwordResetDialog: false,
			resetPassMailSent: false,
			isActive: false,
			submited: false,
			clicked_link: "",
			full_name: this.$store.state.userRegistration.full_name,
			// last_name: this.$store.state.userRegistration.last_name,
			email: this.$store.state.userRegistration.email,
			username: "",
			reset_email: "",
			password: "",
			message: false,
			idDataUpdatedStatus: false,
			name: "",
            business_name: "",
            phone: "",
            sector: "",
            role: ""
		};
	},
	computed: {
		showFreeTrialModel() {
			// Whenever $store.state.show_login_and_freeTrial_model changes, it will cause the computed property to re-evaluate, and trigger associated DOM updates.
			return this.$store.state.toggle_login_and_freeTrial_tab;
		}
	},
	mounted() {
		// window.gapi.load("auth2", () => {
		// const auth2 = window.gapi.auth2.init({
		// 	// WILL NEED TO CHANGE BEFORE MAKING LIVE
		// 	client_id: "832706763983-5okafrpfjg7f8cugscl4pmjn7gih916j.apps.googleusercontent.com",
		// 	scope: "email openid",
		// 	cookiepolicy: "single_host_origin"
		// });
		// auth2.attachClickHandler(
		// 	this.$refs.googleSignIn,
		// 	{},
		// 	googleUser => {
		// 	// console.log("googleUser", googleUser);
		// 	var profile = googleUser.getAuthResponse();
		// 	console.log('profile', profile);
		// 	// serverAddr
		// 	// 	.post("/user/social/auth/login/", {
		// 	// 	username: profile.getEmail(),
		// 	// 	auth_type: "fb/google",
		// 	// 	sign_up_source: 'gmail'
		// 	// 	})
		// 	// 	.then(this.socialLoginUserNetworkCallBack)
		// 	// 	.catch(function(error) {
		// 	// 	console.log(error);
		// 	// 	});
		// 	},
		// 	error => console.log(error)
		// );
		// });
	},
	methods: {
		isDataUpdated() {
			CommonService.isDataUpdated().then(response => {
				// console.log("dataupdated", JSON.parse(response.data).status);
				this.idDataUpdatedStatus = JSON.parse(response.data).status;
			});
		},
		getLoginUserDetails() {
			serverAddr
				.get("/users/self/", {})
				.then(response => {
					this.getLoginInfo(response);
				})
				.catch(error => {
					console.error(error.response);
					if(error.response && error.response.data) {
						this.$notify.error({
							title: "fail",
							message: JSON.parse(error.response.data).name[0]
						});
					}
				});
		},
		showPerticularSection: function(section) {
			if (section == "start_trial") {
				this.$store.commit("showFreeTrialModel", true);
			}
			if (section == "login") {
				this.$store.commit("showFreeTrialModel", false);
				this.$store.commit("openLoginModel", true);
			}
		},
		openForgotPassword: function() {
			this.dialogVisible = false;
			this.passwordResetDialog = true;
			// this.$router.push({
			// 	path: `/user-registration/email-reset-password/`
			// });
		},
		goToUserInformation: function() {
			// console.log("email", this.email);
			this.$validator.validateAll().then(result => {
				if (result) {
					this.dialogVisible = false;
					this.$store.state.userRegistration.full_name = this.full_name;
					// this.$store.state.userRegistration.last_name = this.last_name;
					this.$store.state.userRegistration.email = this.email;
					this.$router.push("/account-setting-nav-bar").catch(()=>{});
					this.$store.commit("showUserInformation", true);
					this.$store.commit("showAccountType", false);
					this.$store.commit("showFinishSetup", false);
					// this.$store.commit("showAccountType", true);
				}
			});
		},
		checkEmailStatus() {
			serverAddr
				.post("/users/status/", {
					email: this.email
				})
				.then(this.userStatus)
				.catch(error => {
					this.$notify.error({
						title: "Error",
						message: JSON.parse(error.response.data).non_field_errors[0],
						type: "Error"
					});
				});
		},
		addRequestStatus() {
			this.$validator.validateAll().then(result => {
				if (result) {
					serverAddr
						.post("/company/contact-us/", {
							name: this.name,
							business_name: this.business_name,
							phone: this.phone,
							email: this.email,
							// sector: this.sector,
							// role: this.role
						})
						.then(res => {
							this.$notify({
								title: "Success",
								message: "Request sent",
								type: "Success"
							});
							this.submited = true;
						})
						.catch(error => {
							this.$notify.error({
								title: "Error",
								message: error,
								type: "Error"
							});
						});
				}
			})
		},
		clickForLogin: function() {
			this.$validator.validateAll().then(result => {
				if (result) {
					serverAddr
						.post("/users/login/", {
							email: this.username,
							password: this.password
						})
						.then(this.postLoginNC)
						.catch(error => {
							this.$notify.error({
								title: "Error",
								message: JSON.parse(error.response.data).non_field_errors[0],
								type: "Error"
							});
						});
					// .catch(function(error) {
					// });
				}
			});
		},
		isEmail(emailAdress){
			let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

		if (emailAdress.match(regex))
			return true;

		else
			return false;
		},
		clickForForgot() {
			if (this.isEmail(this.reset_email)) {
					serverAddr
						.post("/auth/users/reset_password/", {
							email: this.reset_email
						})
						.then((res)=>{
							this.resetPassMailSent = true;
							this.$notify.success({
								title: "Success",
								message: "Please check your mail for reset link."
							});
						}).catch(error => {
							this.resetPassMailSent = false;
							this.$notify.error({
								title: "Error",
								message: JSON.parse(error.response.data)[0]
							});
						});
				} else {
					console.log('Wrong email');
					this.$notify.error({
						title: "Error",
						message: 'Please enter valid email',
					});
				}
		},
		closeLoginDialog() {
			this.$store.state.userRegistration.full_name = "";
			// this.$store.state.userRegistration.last_name = "";
			this.$store.state.userRegistration.email = "";
			this.dialogVisible = false;
			this.$store.commit("openLoginModel", false);
			this.$router.push({ path: `/` }).catch(()=>{});
		},
		errorMessage() {
			this.$notify.error({
				title: "Error",
				message: "This is an error message"
			});
		}
	},
	onlyAlphabets(full_name) {
		// console.log(full_name);
		var key = event.keyCode;
		return (key >= 65 && key <= 90) || key == 8;
		this.message = true;
	}
};
</script>

<style lang="scss" scoped>
@import "./LoginAndFreeTrial.scss";
@import "../../assets/css/variable.scss";
</style>
<style>
/* Element ui dialog css */
/* .LoginAndFreeTrial .el-icon-close {
	display: none;
} */
.vti__dropdown {
	padding: 10px!important;
}
.el-alert__title {
	white-space: pre-line!important;
}
.el-alert__description {
	color: #000!important;
}
.LoginAndFreeTrial .el-dialog {
	height: auto;
	/* max-height: 90%; */
	/* max-width: 650px; */
	width: 680px;
	margin-top: 0 !important;
}
/* close button css */
.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close:hover {
	color: #3d3e3e;
}

.LoginAndFreeTrial .el-dialog__body {
	padding: 0 0 30px 0;
}
.LoginAndFreeTrial .el-dialog__header {
	@apply p-0;
}
.LoginAndFreeTrial .LoginAndFreeTrial_button {
	text-align: right !important;
}
.LoginAndFreeTrial .el-button--primary {
	background-color: #e29d5a!important;
	padding: 13px 12px 11px;
	border-radius: 2px;
	font-size: 15px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff!important;
	border: none;
}
.LoginAndFreeTrial .el-button--primary:hover {
	opacity: 0.9;
}
@media screen and (max-width: 700px) {
	.LoginAndFreeTrial .el-dialog {
		width: 90%;
	}
}
@media screen and (max-width: 576px) {
	.LoginAndFreeTrial .LoginAndFreeTrial_button {
		margin-top: 20px;
		text-align: center !important;
	}
}
.social-media-login-btn {
  box-sizing: border-box;
  position: relative;
  margin: 0.2em;
  padding: 0 15px 0 46px;
  border: none;
  text-align: left;
  line-height: 34px;
  white-space: nowrap;
  border-radius: 0px;
  color: #fff;
  min-width: 100px;
}
.social-media-login-btn:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 100%;
}
.social-media-login-btn:focus {
  outline: none;
}
.social-media-login-btn:active {
  box-shadow: inset 0 0 0 32px rgba(0, 0, 0, 0.1);
}

/* Facebook */
.social-media-login-btn--facebook {
  background-color: #4e69a1;
  background-image: linear-gradient(#4e69a1, #4e69a1);
  text-shadow: 0 -1px 0 #354c8c;
  -webkit-box-shadow: 0 0px 0px -16px #4e69a1;
  box-shadow: 0 0px 5px 0.1px #4e69a1;
  margin: 0 5px;
}
.social-media-login-btn--facebook:hover,
.social-media-login-btn--facebook:focus {
  cursor: pointer;
  background-color: #354c8c;
  background-image: linear-gradient(#44619a, #44619a);
}

/* Google */
.social-media-login-btn--google {
  background: #e29d5a;
  -webkit-box-shadow: 0 0px 0px -16px #e29d5a;
  box-shadow: 0 0px 5px 0.1px #e29d5a;
  margin: 0 5px;
}
.social-media-login-btn--google:hover,
.social-media-login-btn--google:focus {
  cursor: pointer;
  /* background: #e74b37; */
}
.social-media-login-btn--facebook:before {
  background-color:#364e92!important;
  border-radius: 18px 0 0 18px;
  border-right: #364e92 1px solid;
  background: url("../../assets/images/login/facebook-logo.svg")
    6px 6px no-repeat;
  background-position: 10px;
  background-size: 18px;
}
.social-media-login-btn--google:before {
  background-color:#dd8b3c!important;
  /* border-radius: 18px 0 0 18px; */
  border-right: #dd8b3c 1px solid;
  background: url("../../assets/images/login/icons8-google.svg") 6px 6px no-repeat;
  background-position: 10px;
  background-size: 18px;
}
</style>
